import type { ReactNode } from 'react';
import type { IconType } from 'react-icons';

export enum IntegrationCardStatus {
  CONNECTED = 'connected',
  AVAILABLE = 'available',
  CONNECTING = 'connecting',
  ERROR = 'error',
}

export enum IntegrationBusyAction {
  SYNCING = 'syncing',
  DISCONNECTING = 'disconnecting',
}

export enum IntegrationScope {
  PERSONAL = 'personal',
  TEAM = 'team',
}

export enum IntegrationTab {
  ALL = 'all',
  CONNECTED = 'connected',
  AVAILABLE = 'available',
}

export enum IntegrationSort {
  RECENT = 'recent',
  ALPHA = 'alpha',
  STATUS = 'status',
}

export enum IntegrationViewMode {
  GRID = 'grid',
  LIST = 'list',
}

export enum IntegrationCategory {
  ALL = 'all',
  COMMUNICATION = 'communication',
  EMAIL_CALENDAR = 'email_calendar',
  PRODUCTIVITY = 'productivity',
  DATA_AI = 'data_ai',
  DESIGN = 'design',
  MARKETING_CRM = 'marketing_crm',
  DEV = 'dev',
}

export interface IntegrationMcpDetail {
  endpoint: string;
  tools: Array<{ name: string; description: string }>;
}

export interface IntegrationCatalogItem {
  id: string;
  name: string;
  icon: ReactNode;
  category: IntegrationCategory;
  scope: IntegrationScope;
  status: IntegrationCardStatus;
  description: string;
  isMcp: boolean;
  mcpDetail?: IntegrationMcpDetail;
  permissions: string[];
  hasMenu: boolean;
  isAdminOnly?: boolean;
  errorText?: string;
  busyAction?: IntegrationBusyAction;
  manageLabelKey?: string;
  manageIcon?: IconType;
  onConnect?: () => void;
  onRetry?: () => void;
  onManage?: () => void;
  onSync?: () => void;
  onDisconnect?: () => void;
}
